module.exports = __webpack_public_path__ + "img/reminders.eef8efa4.svg";